export default __webpack_public_path__ + "static/media/certificate.1198b92a.png";